import { render, staticRenderFns } from "./SpeakerDetails.vue?vue&type=template&id=5c52819e&"
import script from "./SpeakerDetails.vue?vue&type=script&lang=js&"
export * from "./SpeakerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports